"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELP_REQUEST_URL = exports.HELP_CONTACT_URL = exports.NO_REPLY_EMAIL = void 0;
var NO_REPLY_EMAIL = 'no-reply@upsolve.org';
exports.NO_REPLY_EMAIL = NO_REPLY_EMAIL;
var HELP_CONTACT_URL = 'https://help.upsolve.org/hc/en-us';
exports.HELP_CONTACT_URL = HELP_CONTACT_URL;
var HELP_REQUEST_URL = 'https://help.upsolve.org/hc/en-us/requests/new';
exports.HELP_REQUEST_URL = HELP_REQUEST_URL;